"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ffReactClientSdk = require("@harnessio/ff-react-client-sdk");
var getBrazeFlag = function getBrazeFlag() {
  return (0, _ffReactClientSdk.useFeatureFlag)('DTC_Braze', false);
};
var _default = exports["default"] = getBrazeFlag;